import classNames from 'classnames'
import { Icon } from 'components/common/Icon'

const themes = {
  info: {
    className: 'border-secondary-default bg-secondary-default',
    iconName: 'filled-alert-info',
    iconClassName: 'text-secondary-default',
  },
  success: {
    className: 'bg-success-default border-success-default',
    iconName: 'filled-success',
    iconClassName: 'text-success-default',
  },
  error: {
    className: 'bg-chili-800 border-chili-800',
    iconName: 'filled-close',
    iconClassName: 'text-danger-dark',
  },
  purple: {
    className: 'bg-primary-default border-primary-default !bg-opacity-100',
    iconName: 'filled-alert-info',
    iconClassName: 'text-cool-50',
  },
  'purple-transparent': {
    className:
      'bg-purple-100 border-purple-100 !bg-opacity-100 text-purple-900',
    iconName: 'filled-alert-info',
    iconClassName: 'text-purple-700',
  },
  'primary-light': {
    className: 'bg-primary-light !bg-opacity-100 border-none',
    iconName: 'filled-alert-info',
    iconClassName: 'text-primary-default',
  },
  warning: {
    className: 'bg-warning-light !bg-opacity-100 border-secondary-default/20',
    iconName: 'filled-alert-info',
    iconClassName: 'text-warning-default',
  },
  'warning-default': {
    className: 'bg-warning-default !bg-opacity-50 border-warning-default',
    iconName: 'filled-alert-info',
    iconClassName: 'text-warning-dark',
  },
  gray: {
    className: 'bg-warm-100 !bg-opacity-100 border-transparent',
    iconName: 'filled-alert-info',
    iconClassName: 'text-secondary-default',
  },
} as const

const sizes = {
  sm: 'text-sm px-4 py-3',
  md: 'text-md px-4 py-3',
  base: 'text-base px-4 py-2.5',
} as const

type Props = {
  children?: React.ReactNode
  theme?: keyof typeof themes
  size?: keyof typeof sizes
  className?: string
  iconSize?: number
  iconName?: string
  iconClassName?: string
  fullOpacity?: boolean
  wFull?: boolean
}

export const Info = ({
  children,
  theme = 'info',
  size = 'sm',
  className,
  iconSize = 16,
  iconClassName,
  iconName,
  fullOpacity = false,
  wFull = false,
}: Props) => {
  return (
    <div
      className={classNames(
        'flex items-start rounded border text-cool-800',
        className,
        themes[theme].className,
        sizes[size],
        !fullOpacity && 'border-opacity-10 bg-opacity-5'
      )}
    >
      <Icon
        name={iconName || themes[theme].iconName}
        className={classNames(
          iconClassName,
          themes[theme].iconClassName,
          'mr-2 mt-[2px]',
          fullOpacity && '!text-cool-50'
        )}
        size={iconSize}
        filled
      />
      <div
        className={classNames(fullOpacity && 'text-cool-50', wFull && 'w-full')}
      >
        {children}
      </div>
    </div>
  )
}
